import React, { Component } from 'react';
import { Icon, Checkbox, Popover, Button, Tooltip, Radio, Row, Select, Switch } from '@tinper/next-ui';
import _ from 'lodash';
import { ReactSortable } from 'react-sortablejs'
import { getCompareLogicList } from '../../../utils/meta';
import Common from '../../../assets/images/Common';
import FilterItemManager from '../dataControl/FilterItemManager'

const Option = Select.Option;
export default class RightFilterModal extends Component {
  constructor (props) {
    super(props);
    this.state = {
      settingVisible: false, // 行上"设置"功能弹窗显示标志
      inMouseitemName: ''
    };
  }

  itemMgr = new FilterItemManager(this.props);

  componentWillReceiveProps (nextProps) {
    if (nextProps.ValueList !== this.props.ValueList) {
      this.itemMgr.setValueList(nextProps.ValueList) // 更新值
    }
  }

  // 行内区域的渲染
  AllControlRender = () => {
    const controlRender = []; // control方案设置行内元素，controlRender包含全部元素
    this.commonVosMap = {}; // 用于拖拽数据重组
    // const { ValueList } = this.state;
    this.props.ValueList?.forEach(function (element, index) {
      const { storeField, compareLogic, allowUpdateCompare = true } = element;
      this.commonVosMap[storeField] = element
      // 逻辑下拉框
      const options = [];
      const compareLogicData = getCompareLogicList(element)
      for (const item of compareLogicData) {
        if (this.props.bAdvance && item.value === 'multlike' && !element.mulFieldLike?.length) continue
        const compareLogicItem = (<Option key={item.value}>{item.text}</Option>)
        options.push(compareLogicItem)
      }

      // 用于控制每行的设置弹窗
      const bshowupdown = (storeField == this.state.inMouseitemName); // 通过鼠标划过控制弹窗

      // 设置弹窗部分
      const searchStyleHelper = (<div>
        <p>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80102', '手动搜索：', undefined, { returnDom: true, placement: 'top' })}</p>
        <p>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80103', '当搜索条件改变后，不会立即查询，需要手动点击 [搜索]', undefined, { returnDom: true, placement: 'top' })}</p>
        <p>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80104', '值改变搜索：', undefined, { returnDom: true, placement: 'top' })}</p>
        <p>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80106', '当查询条件值改变后，立即触发搜索', undefined, { returnDom: true, placement: 'top' })}</p>
      </div>)
      // 新交互: 值改变搜索和导航区/查询区 两个功能UI放到一块儿了，之后放到popver里
      const newSettings = (<div className='newSettings'>
        {/* 新交互: 值改变搜索由checkbox改为radio */}
        <div className='autoflt-radio'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80108', '搜索方式', undefined, { returnDom: true, placement: 'top' })}
          <Tooltip placement='top' overlay={searchStyleHelper} overlayClassName='searchStyleTip'><Icon type='uf-a-wenhaomoren' className='searchStyleHelper' /></Tooltip>
          <Radio.Group
            className='mdf-radio'
            value={element.bAutoflt == '1'}
            onChange={(value) => this.itemMgr.autoFlt(index, value)}>
            <Radio value={true}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80100', '值改变搜索', undefined, { returnDom: true, placement: 'top' })}</Radio>
            <Radio value={false}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80101', '手动搜索', undefined, { returnDom: true, placement: 'top' })}</Radio>
          </Radio.Group>
        </div>
        <div className='autoflt-radio'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80105', '是否必填', undefined, { returnDom: true, placement: 'top' })}
          <Switch className='required-switch' checked={element.required} onChange={(value) => this.itemMgr.required(index, value)} />
        </div>
        <div className='autoflt-radio'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A5CF43E04C80007', '允许修改', undefined, { returnDom: true, placement: 'top' })}
          <Switch className='required-switch' checked={element.disabled !== true} onChange={(value) => this.itemMgr.disabled(index, value)} />
        </div>
      </div>)
      // 每行设置及删除区域
      const { authId = {}, ctx = {} } = this.props;
      const hiddenEnableSetting = ctx?.getAuth?.(authId.autoflt)?.authFlag == false || false // 获取权限
      const updown = bshowupdown
        ? <span className='sumarea_list_updown'>
          <Popover
            content={newSettings}
            trigger='click'
            visible={this.state.settingVisible}
            onVisibleChange={() => this.settingVisibleChange()}
            placement='bottomRight'
            positionLeft='-28'
          />
          {!hiddenEnableSetting && <Icon type='uf-settings' className='newSettingIcon' fieldid={`${this.props.fieldid}|itemSetting`} onClick={(e) => this.handleSettingClick(e)} />}
          <Button className='action-guanbi1' fieldid={`${this.props.fieldid}|deleteItem`} onClick={() => { this.itemMgr.deleteItem(index) }}><Icon type='uf-del' /></Button>
        </span>
        : <span />

      // 根据逻辑变化输入框
      // 整理每行设置内容
      const control = (
        <div data-id={storeField} key={storeField}>
          <div
            fieldid={`${this.props.fieldid}|${storeField}`}
            className='query-content-list sumarea_list_item'
            onMouseOver={() => this.onMouseIsenter(true, storeField)}
            onMouseLeave={() => this.onMouseIsenter(false, storeField)}>
            <Icon type="uf-tuodong" className='tuodong'></Icon>
            <div className='query-content-title'><span>{element.caption}</span></div>
            <div className='compareLogic'>
              <Select
                disabled={!allowUpdateCompare}
                getPopupContainer={this.getSelectContainer}
                value={compareLogic || compareLogicData?.[0]?.value}
                style={{ width: 60 }}
                onChange={(value) => this.itemMgr.handleChangeLogic(value, storeField)}
              >
                {options}
              </Select>
            </div>
            <div className='query-component-3'>{this.getComponent(element)}</div>
            {updown}
          </div>
        </div>
      );
      controlRender.push(control)
      // 将设置选项的信息传递出去
    }, this)
    return controlRender
  }

  handleSettingClick (e) {
    this.setState({ settingVisible: !this.state.settingVisible })
  }

  settingVisibleChange () {
    this.setState({ settingVisible: false })
  }

  // 渲染每个查询字段组件
  getComponent (element) {
    // 1. 根据逻辑状态控制输入框状态？，2. 值的获取与回显
    const copyValueList = _.cloneDeep(this.props.ValueList);
    const copyElement = _.cloneDeep(element);
    copyElement.value = copyElement.value ?? '';
    copyElement.visible = true;
    const { value = '' } = copyElement // 应该用于回显
    const referOnChange = (data, { key }) => { // 参照回调
      copyElement.defaultValue = JSON.stringify(data)
      if (copyElement.selectType === "single") {
        copyElement.value = data[0];
      } else {
        copyElement.value = data;
      }
      copyElement.cEntityKeyFld = key;
      this.props.ValueList.forEach((el, index) => {
        if (el.storeField == copyElement.storeField) {
          copyValueList[index] = copyElement;
        }
      })
      this.props.setValueList(copyValueList)
    }
    const onChange = (e) => {
      if (copyElement.controlType === 'ybfilterenumerate' && copyElement.multiple) { // 枚举多选
        copyElement.value = e.join(',');
        copyElement.defaultValue = e.join(',');
      } else {
        copyElement.value = e;
        copyElement.defaultValue = e;
      }
      // 更新参数
      this.props.ValueList.forEach((el, index) => {
        if (el.storeField == copyElement.storeField) {
          copyValueList[index] = copyElement;
        }
      })
      // 用于数据回显
      this.props.setValueList(copyValueList)
    }
    if (copyElement.controlType === 'FilterReferInputPc' || copyElement.controlType === 'FilterReferInput') { // 参照
      return this.props.JSONSchema?.render?.(copyElement, { parentAlias: this.props.parentAlias, onChange: referOnChange })
    } else {
      return this.props.JSONSchema?.render?.(copyElement, { parentAlias: this.props.parentAlias, onChange, value: value || undefined })
    }
  }

  getSelectContainer = (triggerNode) => {
    return document.getElementById('yxyweb-support-mount-popover') || document.body || triggerNode.parentNode;
  }

  // 鼠标移入事件
  onMouseIsenter (Isenter, storeField) {
    if (Isenter) {
      this.setState({ inMouseitemName: storeField });
    } else {
      this.setState({ inMouseitemName: '', settingVisible: false });
    }
  }

  // 拖拽实现
  AddData = () => {
    const { ValueList = [] } = this.props;
    const sortableContent = ValueList?.filter(item => item?.visible === true || item?.visible === undefined)?.length > 0
      ? (<ReactSortable
        animation={200}
        className='query-common'
        setList={this.itemMgr.dragOrder}
        list={ValueList}>
        {this.AllControlRender()}
      </ReactSortable>)
      : (<div>
        <img className='empty-image' src={Common.emptyImage} />
        <span className='empty-text'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010B', '请点击侧栏中的候选条件进行添加', undefined, { returnDom: true, placement: 'top' })}</span>
      </div>)
    return <div className='query-content-ranking'>{sortableContent}</div>
  }

  // 方案右侧区域的渲染
  AddSchemeContent () {
    const { isDefault, autoSearch, authId = {}, ctx = {} } = this.props;
    const hiddenEnableAutoLoad = ctx?.getAuth?.(authId.autoSearch)?.authFlag == false || false // 获取权限
    const hiddenEnableSetDefault = ctx?.getAuth?.(authId.setDefault)?.authFlag == false || false // 获取权限
    const schemeContent = this.AddData();
    const nameContent = (<div className='add-scheme'>
      {!this.props.bAdvance && <Row className='add-scheme-content'>
        <div span={10} className='scheme-set'>
          <span className='settingTitle'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80107', '设置项', undefined, { returnDom: true, placement: 'top' })}</span>
          {!hiddenEnableAutoLoad && <Checkbox checked={autoSearch} fieldid={`${this.props.fieldid}|autoflt`} onClick={this.props.setAutoLoad}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80109', '自动搜索', undefined, { returnDom: true, placement: 'top' })}</Checkbox>}
          {!hiddenEnableSetDefault && <Checkbox checked={isDefault} fieldid={`${this.props.fieldid}|setDefault`} onClick={this.props.setDefault}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010A', '设为默认方案', undefined, { returnDom: true, placement: 'top' })}</Checkbox>}
        </div>
      </Row>}
      {/* 点击添加的规则列表项渲染 */}
      <div>{schemeContent}</div>
    </div>)
    return nameContent
  }

  render () {
    let addScheme = null;
    // 如果非空
    if (this.props.showModal) {
      addScheme = this.AddSchemeContent()
    }
    return <div>{addScheme}</div>;
  }
}
